import { WeatherState, WeatherType, RNG } from '../domain/types.ts';

const WEATHER_DATA: Record<WeatherType, Omit<WeatherState, 'type'>> = {
  sunny: { name: 'Nắng Đẹp', emoji: '☀️', trafficMultiplier: 1.0, description: 'Hôm nay nắng, khách đông!' },
  cloudy: { name: 'Nhiều Mây', emoji: '⛅', trafficMultiplier: 0.9, description: 'Trời mát, khách vừa phải.' },
  rainy: { name: 'Mưa To', emoji: '🌧️', trafficMultiplier: 0.5, description: 'Mưa lớn, ít khách ra đường.' },
  hot: { name: 'Nắng Gắt', emoji: '🥵', trafficMultiplier: 0.8, description: 'Nóng quá, khách ngại ra ngoài.' },
  windy: { name: 'Gió Lạnh', emoji: '💨', trafficMultiplier: 0.7, description: 'Gió mạnh, khách đi vội.' },
};

export class WeatherSystem {
  public static getWeatherForDay(dayNumber: number, rng: RNG): WeatherState {
    const types: WeatherType[] = ['sunny', 'sunny', 'cloudy', 'hot', 'rainy', 'windy', 'cloudy'];
    const idx = Math.floor(rng.next() * types.length);
    // day 1 luôn nắng đẹp để người mới chơi có trải nghiệm tốt
    const type: WeatherType = dayNumber === 1 ? 'sunny' : (types[idx] ?? 'sunny');
    return { type, ...WEATHER_DATA[type] };
  }

  public static applyWeatherToTraffic(baseTraffic: number, weather: WeatherState): number {
    return baseTraffic * weather.trafficMultiplier;
  }
}
